/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplateStepsControllerFindOneQueryResponse, WorkflowTemplateStepsControllerFindOnePathParams, WorkflowTemplateStepsControllerFindOneQueryParams, WorkflowTemplateStepsControllerFindOne400, WorkflowTemplateStepsControllerFindOne401, WorkflowTemplateStepsControllerFindOne403, WorkflowTemplateStepsControllerFindOne404 } from "../../models/workflowsController/WorkflowTemplateStepsControllerFindOne";

function getWorkflowTemplateStepsControllerFindOneUrl(id: WorkflowTemplateStepsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/workflow-template-steps/${id}` as const }  
  return res
}

/**
 * @summary Get a workflow template step by id
 * {@link /api/v1/workflow-template-steps/:id}
 */
export async function workflowTemplateStepsControllerFindOne(id: WorkflowTemplateStepsControllerFindOnePathParams["id"], params?: WorkflowTemplateStepsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowTemplateStepsControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerFindOne400 | WorkflowTemplateStepsControllerFindOne401 | WorkflowTemplateStepsControllerFindOne403 | WorkflowTemplateStepsControllerFindOne404>, unknown>({ method : "GET", url : getWorkflowTemplateStepsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}